import FullPreset from "./full/full"
import { getFullMenu } from "./full/fullMenu"
import MinimalPreset from "./minimal/minimal"
import { getMinimalMenu } from "./minimal/minimalMenu"
import SimplePreset from "./simple/simple"
import { getSimpleMenu } from "./simple/simpleMenu"

export const presets = {
  minimal: {
    options: MinimalPreset,
    getMenu: getMinimalMenu,
  },
  simple: {
    options: SimplePreset,
    getMenu: getSimpleMenu,
  },
  full: {
    options: FullPreset,
    getMenu: getFullMenu,
  },
  // A custom preset includes all options from the full preset but is tweaked by the consumer
  // Ref: customPresetExtensions and customPresetMenu props in the RichText component
  custom: {
    options: FullPreset,
    getMenu: getFullMenu,
  },
}
